module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-600.8d1f9676.woff";